// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor-pointer {
  cursor: pointer !important;
}

.item-card {
  background: white;
  border-radius: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  cursor: pointer;
  transition: box-shadow 0.2s ease;
  border: none;
  display: flex;
  flex-direction: column;
  height: 210px;
}
@media (max-width: 992px) {
  .item-card {
    height: 210px;
  }
}
.item-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.item-card .card-header {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  width: 24px;
  height: 24px;
}
.item-card .card-header .info-icon {
  width: 100%;
  height: 100%;
  color: #666;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  box-sizing: border-box;
}
.item-card .card-content {
  display: flex;
  flex: 1;
  padding: 0;
}
.item-card .card-content .image-section {
  width: 160px;
  height: 210px;
  flex-shrink: 0;
}
@media (min-width: 991px) and (max-width: 1399px) {
  .item-card .card-content .image-section {
    width: 140px;
  }
}
@media (max-width: 992px) {
  .item-card .card-content .image-section {
    height: 210px;
  }
}
.item-card .card-content .image-section .item-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
  display: block;
}
.item-card .card-content .text-section {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-right: 40px;
  height: 210px;
  justify-content: space-between;
}
@media (max-width: 992px) {
  .item-card .card-content .text-section {
    height: 210px;
  }
}
.item-card .card-content .text-section .content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}
.item-card .card-content .text-section .content-area .item-name {
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  color: #1a1a18;
  margin: 0 0 0 0;
  line-height: 1.2;
  flex-shrink: 0;
  overflow-wrap: anywhere;
}
@media (min-width: 991px) and (max-width: 1399px) {
  .item-card .card-content .text-section .content-area .item-name {
    font-size: 16px;
  }
}
.item-card .card-content .text-section .content-area .item-name ion-icon {
  width: 20px;
  height: 17px;
}
.item-card .card-content .text-section .content-area .item-name ion-icon.smaller {
  width: 28px;
  height: 20px;
}
.item-card .card-content .text-section .content-area .item-name ion-icon.papper + .papper {
  margin-left: -4px;
}
.item-card .card-content .text-section .content-area .item-description {
  font-size: 14px;
  color: #666;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 2.8em;
  flex: 0 1 auto;
  min-height: 0;
}
@media (max-width: 992px) {
  .item-card .card-content .text-section .content-area .item-description {
    -webkit-line-clamp: 1;
    max-height: 1.4em;
  }
}
.item-card .card-content .text-section .content-area .measurement {
  font-size: 12px;
  color: #666;
  margin: 0 0 4px 0;
  flex-shrink: 0;
}
.item-card .card-content .text-section .content-area .price-info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0 0 4px 0;
}
.item-card .card-content .text-section .content-area .item-price {
  font-size: 16px;
  font-weight: bold;
  color: #1a1a18;
  margin: 0;
  flex-shrink: 0;
}
.item-card .card-content .text-section .content-area .legal-text {
  margin-top: 4px;
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.item-card .card-content .text-section .content-area .legal-text .measurement-text,
.item-card .card-content .text-section .content-area .legal-text .pfand-text {
  font-size: 10px;
  color: #888;
  margin: 0;
  line-height: 1.2;
  white-space: nowrap;
}
.item-card .card-content .text-section .content-area .item-info {
  font-size: 12px;
  color: #666;
  text-align: right;
  flex-shrink: 0;
}
.item-card .card-content .text-section .content-area .deposit-info {
  margin: 0;
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
}
.item-card .card-content .text-section .action-area {
  flex-shrink: 0;
  margin-top: auto;
}
.item-card .card-content .text-section .action-area .action-columns {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px;
}
.item-card .card-content .text-section .action-area .action-columns .info-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.item-card .card-content .text-section .action-area .action-columns .info-column .measurement {
  font-size: 12px;
  color: #666;
  margin: 0 0 4px 0;
}
.item-card .card-content .text-section .action-area .action-columns .info-column .deposit-info {
  margin: 0;
  font-size: 12px;
  color: #666;
}
.item-card .card-content .text-section .action-area .dotted-divider {
  position: relative;
  height: 10px;
  margin: 8px 0 12px 0;
  width: 100%;
}
.item-card .card-content .text-section .action-area .dotted-divider::before, .item-card .card-content .text-section .action-area .dotted-divider::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  border-bottom: 2px dotted #d0d0d0;
}
.item-card .card-content .text-section .action-area .dotted-divider::before {
  top: 0;
}
.item-card .card-content .text-section .action-area .dotted-divider::after {
  bottom: 0;
}
.item-card .card-content .text-section .action-area .action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
}
.item-card .card-content .text-section .action-area .action-buttons .anpassen-btn {
  --border-color: #1a1a18;
  color: #1a1a18;
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  background-hover: rgba(0, 0, 0, 0.05);
  height: 32px;
  border-radius: 0;
  font-size: 12px;
  font-weight: 500;
  padding: 0 12px 0 16px;
}
.item-card .card-content .text-section .action-area .action-buttons .anpassen-btn .edit-icon {
  width: 14px;
  height: 14px;
  margin-left: 6px;
  color: #1a1a18;
}
.item-card .card-content .text-section .action-area .action-buttons .add-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border: 2px solid #1a1a18;
  cursor: pointer;
}
.item-card .card-content .text-section .action-area .action-buttons .add-icon:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.05);
}
.item-card .card-content .text-section .action-area .action-buttons .add-icon .plus-icon {
  width: 18px;
  height: 18px;
  color: #000;
}
.item-card .card-content .text-section .action-area .action-buttons .add-icon.in-cart {
  background: #ff4757;
  border-color: #ff4757;
  opacity: 1;
}
.item-card .card-content .text-section .action-area .action-buttons .add-icon.in-cart .plus-icon {
  color: white;
}
.item-card .card-content .text-section .action-area .action-buttons .add-icon.in-cart:hover {
  background: #e63946;
}

.item-name {
  font-family: AppFontBold, sans-serif;
}

.item-info {
  font-size: 12px;
  color: #666;
}
.item-info.pfand {
  height: unset;
}

.price {
  font-family: AppFontBold, sans-serif;
  color: #1a1a18;
}

.small-screen {
  display: block;
}
@media (max-width: 992px) {
  .small-screen {
    display: block;
  }
}

.big-screen {
  display: none;
  padding: 0px;
  margin: 0px;
}
@media (min-width: 991px) {
  .big-screen {
    display: block;
  }
  .big-screen .desktop_info_block {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    min-height: 160px;
    height: 100%;
  }
  .big-screen .desktop_info_block .left {
    width: 65%;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 5px 10px 10px;
  }
  .big-screen .desktop_info_block .left .desktop-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  .big-screen .desktop_info_block .left .desktop-header .info-icon {
    width: 20px;
    height: 20px;
    color: #666;
    flex-shrink: 0;
    margin-left: 8px;
    margin-top: 2px;
  }
  .big-screen .desktop_info_block .left .item-name {
    font-size: 25px;
    line-height: 25px;
    margin: 0px;
    flex: 1;
  }
  .big-screen .desktop_info_block .left .item-description {
    -webkit-line-clamp: 2;
    font-size: 14px;
    line-height: 15px;
    color: #666;
    margin: 8px 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .big-screen .desktop_info_block .left .price {
    font-family: AppFonBold, sans-serif !important;
    font-weight: bold;
  }
  .big-screen .desktop_info_block .left .desktop-footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 12px;
  }
  .big-screen .desktop_info_block .left .desktop-footer .price-section {
    flex: 1;
  }
  .big-screen .desktop_info_block .left .desktop-footer .desktop-actions {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  .big-screen .desktop_info_block .left .desktop-footer .desktop-actions .anpassen-btn {
    --border-color: #000;
    --color: #000;
    --background: transparent;
    --background-activated: transparent;
    --background-focused: transparent;
    --background-hover: rgba(0, 0, 0, 0.05);
    height: 36px;
    border-radius: 0;
    font-size: 14px;
    font-weight: 600;
    border: 1px solid #000;
    padding: 0 12px 0 16px;
  }
  .big-screen .desktop_info_block .left .desktop-footer .desktop-actions .anpassen-btn .edit-icon {
    width: 16px;
    height: 16px;
    margin-left: 8px;
    color: #000;
  }
  .big-screen .desktop_info_block .left .desktop-footer .desktop-actions .add-btn {
    --background: var(--ion-color-primary);
    width: 36px;
    height: 36px;
    --border-radius: 18px;
  }
  .big-screen .desktop_info_block .right {
    width: 35%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .big-screen .desktop_info_block .right ion-img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}

.cover-image {
  object-fit: cover;
  margin: 0px !important;
  border-radius: 8px;
}

.bigger {
  zoom: 1.3;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: right;
  margin-top: 7px;
}
@media (max-width: 992px) {
  .measurment_text {
    text-align: left;
  }
}

.vat {
  color: black;
  font-size: 10px;
}

.measurement {
  font-family: AppFont;
  font-size: 11px;
  color: #1a1a18;
  margin: 4px 0 2px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGA;EACC,0BAAA;AAFD;;AAMA;EACC,iBAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAHD;ACRE;EDCF;IAaE,aAAA;EAFA;AACF;AAIC;EACC,0CAAA;AAFF;AAMC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAJF;AAME;EACC,WAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,sBAAA;AAJH;AASC;EACC,aAAA;EACA,OAAA;EACA,UAAA;AAPF;AAUE;EACC,YAAA;EACA,aAAA;EACA,cAAA;AARH;AClCE;EDuCA;IAME,YAAA;EAPF;AACF;AC/CE;ED+CA;IAUE,aAAA;EANF;AACF;AAQG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AANJ;AAWE;EACC,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AATH;ACrEE;EDsEA;IAWE,aAAA;EARF;AACF;AAWG;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AATJ;AAWI;EACC,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AATL;ACnFE;EDoFE;IAWE,eAAA;EARJ;AACF;AAUK;EACC,WAAA;EACA,YAAA;AARN;AASM;EACC,WAAA;EACA,YAAA;AAPP;AAUM;EACC,iBAAA;AARP;AAaI;EACC,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AAXL;ACzHE;EDwHE;IAeE,qBAAA;IACA,iBAAA;EAVJ;AACF;AAaI;EACC,eAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAXL;AAcI;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,iBAAA;AAZL;AAeI;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,cAAA;AAbL;AAiBI;EACC,eAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AAfL;AAiBK;;EAEC,eAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAfN;AAmBI;EACC,eAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAjBL;AAoBI;EACC,SAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AAlBL;AAuBG;EACC,cAAA;EACA,gBAAA;AArBJ;AAuBI;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;AArBL;AAuBK;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AArBN;AAuBM;EACC,eAAA;EACA,WAAA;EACA,iBAAA;AArBP;AAwBM;EACC,SAAA;EACA,eAAA;EACA,WAAA;AAtBP;AA4BI;EACC,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AA1BL;AA4BK;EAEC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,iCAAA;AA3BN;AA8BK;EACC,MAAA;AA5BN;AA+BK;EACC,SAAA;AA7BN;AAkCI;EACC,aAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;AAhCL;AAkCK;EACC,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,qCAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAhCN;AAkCM;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAhCP;AAoCK;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;AAlCN;AAoCM;EACC,UAAA;EACA,+BAAA;AAlCP;AAqCM;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAnCP;AAsCM;EACC,mBAAA;EACA,qBAAA;EACA,UAAA;AApCP;AAsCO;EACC,YAAA;AApCR;AAuCO;EACC,mBAAA;AArCR;;AAkDA;EACC,oCAAA;AA/CD;;AAkDA;EACC,eAAA;EACA,WAAA;AA/CD;AAiDC;EACC,aAAA;AA/CF;;AAoDA;EACC,oCAAA;EACA,cAAA;AAjDD;;AAqDA;EACC,cAAA;AAlDD;ACzSE;ED0VF;IAGE,cAAA;EAhDA;AACF;;AAkDA;EACC,aAAA;EACA,YAAA;EACA,WAAA;AA/CD;AC1TE;EDsWF;IAKE,cAAA;EA7CA;EA+CA;IACC,aAAA;IACA,uBAAA;IACA,8BAAA;IACA,iBAAA;IACA,YAAA;EA7CD;EA8CC;IACC,UAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,8BAAA;IACA,2BAAA;EA5CF;EA8CE;IACC,aAAA;IACA,uBAAA;IACA,8BAAA;IACA,kBAAA;EA5CH;EA8CG;IACC,WAAA;IACA,YAAA;IACA,WAAA;IACA,cAAA;IACA,gBAAA;IACA,eAAA;EA5CJ;EAgDE;IACC,eAAA;IACA,iBAAA;IACA,WAAA;IACA,OAAA;EA9CH;EAgDE;IACC,qBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;IACA,aAAA;IACA,oBAAA;IACA,4BAAA;IACA,gBAAA;EA9CH;EAgDE;IACC,8CAAA;IACA,iBAAA;EA9CH;EAiDE;IACC,aAAA;IACA,qBAAA;IACA,8BAAA;IACA,gBAAA;EA/CH;EAiDG;IACC,OAAA;EA/CJ;EAkDG;IACC,aAAA;IACA,QAAA;IACA,mBAAA;EAhDJ;EAkDI;IACC,oBAAA;IACA,aAAA;IACA,yBAAA;IACA,mCAAA;IACA,iCAAA;IACA,uCAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,sBAAA;EAhDL;EAkDK;IACC,WAAA;IACA,YAAA;IACA,gBAAA;IACA,WAAA;EAhDN;EAoDI;IACC,sCAAA;IACA,WAAA;IACA,YAAA;IACA,qBAAA;EAlDL;EAuDC;IACC,UAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EArDF;EAsDE;IACC,YAAA;IACA,WAAA;IACA,mBAAA;EApDH;AACF;;AAyDA;EACC,iBAAA;EACA,sBAAA;EACA,kBAAA;AAtDD;;AAwDA;EACC,SAAA;AArDD;;AAuDA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AApDD;AChbE;ED+dF;IAOE,gBAAA;EAlDA;AACF;;AAoDA;EACC,YAAA;EACA,eAAA;AAjDD;;AAoDA;EACC,oBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAjDD","sourcesContent":["@import '../../../theme/mixins';\n\n// Utility classes\n.cursor-pointer {\n\tcursor: pointer !important;\n}\n\n// Main card styling - larger cards to show 2.5 on screen\n.item-card {\n\tbackground: white;\n\tborder-radius: 0; // Removed border radius\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\tposition: relative;\n\tcursor: pointer;\n\ttransition: box-shadow 0.2s ease;\n\tborder: none; // Removed white border\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 210px; // Fixed height for consistency\n\n\t@include mobile {\n\t\theight: 210px; // Slightly taller on mobile for better content fit\n\t}\n\n\t&:hover {\n\t\tbox-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n\t}\n\n\t// Info icon in top right corner - positioned inside card\n\t.card-header {\n\t\tposition: absolute;\n\t\ttop: 12px;\n\t\tright: 12px;\n\t\tz-index: 2;\n\t\twidth: 24px;\n\t\theight: 24px;\n\n\t\t.info-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tcolor: #666;\n\t\t\tbackground: rgba(255, 255, 255, 0.9);\n\t\t\tborder-radius: 50%;\n\t\t\tbox-sizing: border-box;\n\t\t}\n\t}\n\n\t// Main content area\n\t.card-content {\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\tpadding: 0;\n\n\t\t// Image section (left) - fixed height\n\t\t.image-section {\n\t\t\twidth: 160px; // Increased from 120px to make more square\n\t\t\theight: 210px; // Match card height\n\t\t\tflex-shrink: 0;\n\n\t\t\t@include tablet {\n\t\t\t\twidth: 140px; // give text section more room at narrow desktop widths\n\t\t\t}\n\n\t\t\t@include mobile {\n\t\t\t\theight: 210px; // Match mobile card height\n\t\t\t}\n\n\t\t\t.item-image {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t\tborder-radius: 0; // Removed border radius\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\n\t\t// Text content (right)\n\t\t.text-section {\n\t\t\tflex: 1;\n\t\t\tmin-width: 0; // allow flex item to shrink below intrinsic width — needed so the text wraps instead of overflowing on narrow cards\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tpadding: 16px;\n\t\t\tpadding-right: 40px; // Space for info icon (icon spans 36px from right edge)\n\t\t\theight: 210px; // Match card height\n\t\t\tjustify-content: space-between;\n\n\t\t\t@include mobile {\n\t\t\t\theight: 210px; // Match mobile card height\n\t\t\t}\n\n\t\t\t// Top content area - flexible height\n\t\t\t.content-area {\n\t\t\t\tflex: 1;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\toverflow: hidden;\n\t\t\t\tmin-height: 0; // Allow children to shrink within available space\n\n\t\t\t\t.item-name {\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: #1a1a18;\n\t\t\t\t\tmargin: 0 0 0 0;\n\t\t\t\t\tline-height: 1.2;\n\t\t\t\t\tflex-shrink: 0; // Don't shrink title\n\t\t\t\t\toverflow-wrap: anywhere; // break very long words instead of overflowing\n\n\t\t\t\t\t@include tablet {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\n\t\t\t\t\tion-icon {\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\theight: 17px;\n\t\t\t\t\t\t&.smaller {\n\t\t\t\t\t\t\twidth: 28px;\n\t\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t// Stacked spice level icons sit tight together, as in the printed menu\n\t\t\t\t\t\t&.papper + .papper {\n\t\t\t\t\t\t\tmargin-left: -4px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.item-description {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tcolor: #666;\n\t\t\t\t\tmargin: 0 0 8px 0;\n\t\t\t\t\tline-height: 1.4;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\tmax-height: calc(1.4em * 2); // Exactly 2 lines based on line-height\n\t\t\t\t\tflex: 0 1 auto; // Allow description to shrink first when space is tight (e.g. browser zoom 125%+)\n\t\t\t\t\tmin-height: 0;\n\n\t\t\t\t\t@include mobile {\n\t\t\t\t\t\t-webkit-line-clamp: 1;\n\t\t\t\t\t\tmax-height: calc(1.4em * 1); // Only 1 line on mobile\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.measurement {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tcolor: #666;\n\t\t\t\t\tmargin: 0 0 4px 0;\n\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t}\n\n\t\t\t\t.price-info-row {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\tmargin: 0 0 4px 0;\n\t\t\t\t}\n\n\t\t\t\t.item-price {\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tcolor: #1a1a18;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t}\n\n\t\t\t\t// Legal compliance text (measurement and Pfand)\n\t\t\t\t.legal-text {\n\t\t\t\t\tmargin-top: 4px;\n\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tgap: 8px;\n\t\t\t\t\tflex-wrap: wrap;\n\n\t\t\t\t\t.measurement-text,\n\t\t\t\t\t.pfand-text {\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\tcolor: #888;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tline-height: 1.2;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.item-info {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tcolor: #666;\n\t\t\t\t\ttext-align: right;\n\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t}\n\n\t\t\t\t.deposit-info {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tcolor: #666;\n\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Bottom action area - fixed height\n\t\t\t.action-area {\n\t\t\t\tflex-shrink: 0;\n\t\t\t\tmargin-top: auto;\n\n\t\t\t\t.action-columns {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\talign-items: flex-end;\n\t\t\t\t\tgap: 12px;\n\n\t\t\t\t\t.info-column {\n\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\talign-items: flex-start;\n\n\t\t\t\t\t\t.measurement {\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tcolor: #666;\n\t\t\t\t\t\t\tmargin: 0 0 4px 0;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.deposit-info {\n\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tcolor: #666;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Double dotted divider with space between lines\n\t\t\t\t.dotted-divider {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\theight: 10px;\n\t\t\t\t\tmargin: 8px 0 12px 0;\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\t&::before,\n\t\t\t\t\t&::after {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\theight: 2px;\n\t\t\t\t\t\tborder-bottom: 2px dotted #d0d0d0;\n\t\t\t\t\t}\n\n\t\t\t\t\t&::before {\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t}\n\n\t\t\t\t\t&::after {\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Action buttons below divider\n\t\t\t\t.action-buttons {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tgap: 8px;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: flex-end;\n\n\t\t\t\t\t.anpassen-btn {\n\t\t\t\t\t\t--border-color: #1a1a18;\n\t\t\t\t\t\tcolor: #1a1a18;\n\t\t\t\t\t\t--background: transparent;\n\t\t\t\t\t\t--background-activated: transparent;\n\t\t\t\t\t\t--background-focused: transparent;\n\t\t\t\t\t\tbackground-hover: rgba(0, 0, 0, 0.05);\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tpadding: 0 12px 0 16px;\n\n\t\t\t\t\t\t.edit-icon {\n\t\t\t\t\t\t\twidth: 14px;\n\t\t\t\t\t\t\theight: 14px;\n\t\t\t\t\t\t\tmargin-left: 6px;\n\t\t\t\t\t\t\tcolor: #1a1a18;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.add-icon {\n\t\t\t\t\t\twidth: 32px;\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\ttransition: all 0.2s ease;\n\t\t\t\t\t\tborder: 2px solid #1a1a18;\n\t\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\tbackground: rgba(0, 0, 0, 0.05);\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.plus-icon {\n\t\t\t\t\t\t\twidth: 18px;\n\t\t\t\t\t\t\theight: 18px;\n\t\t\t\t\t\t\tcolor: #000;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&.in-cart {\n\t\t\t\t\t\t\tbackground: #ff4757;\n\t\t\t\t\t\t\tborder-color: #ff4757;\n\t\t\t\t\t\t\topacity: 1;\n\n\t\t\t\t\t\t\t.plus-icon {\n\t\t\t\t\t\t\t\tcolor: white;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground: #e63946;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Remove old footer styles - now integrated into price-actions-row\n}\n\n// Legacy styles for backward compatibility\n.item-name {\n\tfont-family: AppFontBold, sans-serif;\n}\n\n.item-info {\n\tfont-size: 12px;\n\tcolor: #666;\n\n\t&.pfand {\n\t\theight: unset;\n\t}\n}\n\n// Legacy styles - mostly removed, kept for desktop compatibility if needed\n.price {\n\tfont-family: AppFontBold, sans-serif;\n\tcolor: #1a1a18;\n}\n// Legacy img-block - replaced with new image-section\n\n.small-screen {\n\tdisplay: block;\n\t@include mobile {\n\t\tdisplay: block;\n\t}\n}\n.big-screen {\n\tdisplay: none;\n\tpadding: 0px;\n\tmargin: 0px;\n\t@include desktop {\n\t\tdisplay: block;\n\n\t\t.desktop_info_block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-start;\n\t\t\tjustify-content: space-between;\n\t\t\tmin-height: 160px;\n\t\t\theight: 100%;\n\t\t\t.left {\n\t\t\t\twidth: 65%;\n\t\t\t\tdisplay: flex;\n\t\t\t\theight: 100%;\n\t\t\t\tflex-direction: column;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tpadding: 10px 5px 10px 10px;\n\n\t\t\t\t.desktop-header {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tmargin-bottom: 8px;\n\n\t\t\t\t\t.info-icon {\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\tcolor: #666;\n\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\t\tmargin-top: 2px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.item-name {\n\t\t\t\t\tfont-size: 25px;\n\t\t\t\t\tline-height: 25px;\n\t\t\t\t\tmargin: 0px;\n\t\t\t\t\tflex: 1;\n\t\t\t\t}\n\t\t\t\t.item-description {\n\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 15px;\n\t\t\t\t\tcolor: #666;\n\t\t\t\t\tmargin: 8px 0;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t}\n\t\t\t\t.price {\n\t\t\t\t\tfont-family: AppFonBold, sans-serif !important;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t}\n\n\t\t\t\t.desktop-footer {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: flex-end;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tmargin-top: 12px;\n\n\t\t\t\t\t.price-section {\n\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t}\n\n\t\t\t\t\t.desktop-actions {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tgap: 8px;\n\t\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t\t.anpassen-btn {\n\t\t\t\t\t\t\t--border-color: #000;\n\t\t\t\t\t\t\t--color: #000;\n\t\t\t\t\t\t\t--background: transparent;\n\t\t\t\t\t\t\t--background-activated: transparent;\n\t\t\t\t\t\t\t--background-focused: transparent;\n\t\t\t\t\t\t\t--background-hover: rgba(0, 0, 0, 0.05);\n\t\t\t\t\t\t\theight: 36px;\n\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\tborder: 1px solid #000;\n\t\t\t\t\t\t\tpadding: 0 12px 0 16px;\n\n\t\t\t\t\t\t\t.edit-icon {\n\t\t\t\t\t\t\t\twidth: 16px;\n\t\t\t\t\t\t\t\theight: 16px;\n\t\t\t\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\t\t\t\tcolor: #000;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.add-btn {\n\t\t\t\t\t\t\t--background: var(--ion-color-primary);\n\t\t\t\t\t\t\twidth: 36px;\n\t\t\t\t\t\t\theight: 36px;\n\t\t\t\t\t\t\t--border-radius: 18px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.right {\n\t\t\t\twidth: 35%;\n\t\t\t\theight: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tion-img {\n\t\t\t\t\theight: 100%;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tobject-fit: contain;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.cover-image {\n\tobject-fit: cover;\n\tmargin: 0px !important;\n\tborder-radius: 8px;\n}\n.bigger {\n\tzoom: 1.3;\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\ttext-align: right;\n\tmargin-top: 7px;\n\t@include mobile {\n\t\ttext-align: left;\n\t}\n}\n.vat {\n\tcolor: black;\n\tfont-size: 10px;\n}\n\n.measurement {\n\tfont-family: AppFont;\n\tfont-size: 11px;\n\tcolor: #1a1a18;\n\tmargin: 4px 0 2px 0;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
